import {BuType} from "./bu-types";

export class Bu {
  static readonly bus = [
    new Bu("se", "assets/ic_sweden.svg", "Sweden"),
    new Bu("no", "assets/ic_norway.svg", "Norway"),
    new Bu("uk", "assets/ic_uk.png", "United Kingdom"),
    new Bu("de", "assets/ic_germany.svg", "Germany"),
  ]
  bu: BuType;
  flagUrl: string;
  buName: string;

  constructor(bu: BuType, flagUrl: string, buName: string) {
    this.bu = bu;
    this.flagUrl = flagUrl;
    this.buName = buName;
  }

  static getBu(bu: string) {


    switch (bu) {
      case "se": {
        return this.bus[0];
      }
      case "no": {
        return this.bus[1];
      }
      case "uk": {
        return this.bus[2];
      }

      default : {
        return this.bus[3];
      }

    }

  }
}

